"use client"
import { GridIcon } from "@/app/icons/grid"
import { TableIcon } from "@/app/icons/table"
import { useLingui } from "@lingui/react/macro"
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@rarible_int/anaconda_ui_components"
import { useCallback } from "react"
import { ViewType } from "./types"

interface Props {
  value: ViewType
  onChange: (value: ViewType) => void
}

export function ViewSelector({ value = ViewType.GRID, onChange }: Props) {
  const { t } = useLingui()

  const onValueChange = useCallback(
    (value: string) => {
      if (value) {
        onChange(value as ViewType)
      }
    },
    [onChange],
  )

  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={onValueChange}
      className="rounded-full border p-[3px]"
      data-testid="view-selector"
    >
      <ToggleGroupItem
        className="h-7 min-w-0 px-[6px] [&_svg]:size-5"
        key={ViewType.GRID}
        value={ViewType.GRID}
        aria-label={t`Grid view`}
      >
        <GridIcon className="h-5 w-5" />
      </ToggleGroupItem>
      <ToggleGroupItem
        className="h-7 min-w-0 px-[6px] [&_svg]:size-5"
        key={ViewType.TABLE}
        value={ViewType.TABLE}
        aria-label={t`Table view`}
      >
        <TableIcon className="h-5 w-5" />
      </ToggleGroupItem>
    </ToggleGroup>
  )
}
